var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_11492",
    transform: "translate(-0.142)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441_385",
    cx: 21.5,
    cy: 21.5,
    r: 21.5,
    transform: "translate(0.142)",
    fill: "#EA8024"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_26416",
    d: "M4648.431-11403.969c2.313-1.275,4.9-2.338,7.308-3.406,4.15-1.752,8.319-3.473,12.527-5.073.82-.273,2.29-.541,2.434.673-.079,1.718-.4,3.428-.626,5.135-.564,3.756-1.219,7.5-1.857,11.241a1.772,1.772,0,0,1-2.781,1.1c-2.4-1.625-4.822-3.231-7.193-4.894-.776-.787-.056-1.922.637-2.483,1.979-1.951,4.077-3.607,5.952-5.656.505-1.223-.989-.191-1.482.121-2.709,1.869-5.35,3.85-8.206,5.487-1.459.8-3.158.119-4.616-.331-1.308-.541-3.223-1.084-2.1-1.911Z",
    transform: "translate(-4640.859 11426.297)",
    fill: "#f6f6f6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.b7fa9218ebec987935e814f1258b25f5.svg";
export { ForwardRef as ReactComponent };